var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallWhiteWallet = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "display/small/tertiary/wallet") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "display/small/tertiary/wallet",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/wallet",
    transform: "translate(4, 5)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wallet-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8781395,14.88 C15.3267572,14.88 14.0651163,13.58832 14.0651163,12 C14.0651163,10.41168 15.3267572,9.12 16.8781395,9.12 L20.16,9.12 L20.16,4.32 C20.16,4.05504 19.9499609,3.84 19.6911628,3.84 L2.34418605,3.84 C1.5687293,3.84 0.937674419,3.19392 0.937674419,2.4 C0.937674419,1.60608 1.5687293,0.96 2.34418605,0.96 L15.0027907,0.96 L15.0027907,2.88 L15.9404651,2.88 L15.9404651,0.48 C15.9404651,0.21504 15.730426,0 15.4716279,0 L2.34418605,0 C1.05160186,0 0,1.07664 0,2.4 L0,16.8 C0,18.6528 1.47214884,20.16 3.28186047,20.16 L19.6911628,20.16 C19.9499609,20.16 20.16,19.94496 20.16,19.68 L20.16,14.88 L16.8781395,14.88 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1371429,10.08 L16.9714286,10.08 C15.9503657,10.08 15.12,10.8873 15.12,11.88 C15.12,12.8727 15.9503657,13.68 16.9714286,13.68 L21.1371429,13.68 C21.39264,13.68 21.6,13.4784 21.6,13.23 L21.6,10.53 C21.6,10.2816 21.39264,10.08 21.1371429,10.08 Z",
    id: "Path"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallWhiteWallet);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-white-wallet.43fa92201d2519c4bcdd68428790cdf5.svg";